import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationOriginIntegrationInstallUrlArgs } from "types/generated";

type OriginIntegrationInstallURLData = {
  originIntegrationInstallURL: string;
};

export const ORIGIN_INTEGRATION_INSTALL_URL: TypedDocumentNode<
  OriginIntegrationInstallURLData,
  MutationOriginIntegrationInstallUrlArgs
> = gql`
  mutation OriginIntegrationInstallURL($spaceID: ID) {
    originIntegrationInstallURL(spaceID: $spaceID)
  }
`;
